module.exports = __webpack_public_path__ + "img/avatar0.8f4bb528.png";